<template>
  <div class="about">
    <Header></Header>
    <div class="banner">
      <h3>让数据驱动一切</h3>
      <div class="subfield">
        <div class="subfield-box width_fixed">
          <ul>
            <li :class="{'active': isShow=='introduce'}" @click="handleSubfield('introduce')">公司介绍</li>
            <li :class="{'active': isShow=='develop'}" @click="handleSubfield('develop')">发展历程</li>
          </ul>
        </div>
      </div>
    </div>
    <main class="width_fixed">
      <div v-if="isShow==='introduce'" class="introduce">
        <h4 class="title">公司简介</h4>
        <p>霖梓控股是一家以数据驱动决策的互联网科技公司，用创新的产品深度赋能产业，从而不断提升用户的生活品质。</p>
        <p>霖梓控股2017年创办于中国杭州，公司以“数据驱动”为 核心导向，专注于深度学习＋人工智能结合应用，形成高效简单的科技服务产品， 支持合作伙伴实现数字化转型，促进业务发展，更好的服务用户。</p>
        <p>霖梓控股创建的智能家庭健身品牌，为全球健身爱好者，带来全新的居家健身体验。提供趣味、解压和富有竞争的科技健身概念。依托行业领先的大数据处理能力，霖梓控股还提供物流管理、物业管理等一系列企业服务。霖梓控股旗下“百凌金科”、“易借速贷”、“PITPAT”等均是行业内具有影响力的创新品牌。</p>
        <p>霖梓控股主要管理者均来自阿里巴巴、银行等世界500强企业，在大数据应用、大数据风控、人工智能、 互联网运营等领域拥有成熟且成功的经验，具备强劲实力与市场竞争力。公司始终坚持“相信、包容、担当、求真、极致、用户第一” 的价值观，致力于让数据驱动决策、赋能产业。</p>
        <div class="icon-box">
          <dl>
            <img src="@/assets/img/pc/about/about-icon1.png">
            <dd>公司使命</dd>
            <dd>让business更美好，一点点</dd>
          </dl>
          <dl>
            <img src="@/assets/img/pc/about/about-icon2.png">
            <dd>愿景</dd>
            <dd>一家受人尊敬的活60年的企业</dd>
          </dl>
          <dl>
            <img src="@/assets/img/pc/about/about-icon3.png">
            <dd>核心价值观</dd>
            <dd>相信、包容、担当、求真、极致、用户第一</dd>
          </dl>
        </div>
      </div>
      <div v-if="isShow==='develop'" class="develop">
        <h4 class="title">发展历程</h4>
        <div class="content">
          <div class="progress">
            <i></i>
            <img src="@/assets/img/pc/about/arrowTop.png" style="width: 20px; height: 20px; margin-left: -10px;">
          </div>
          <div class="content-wrap">
            <div 
              v-for="(it, index) in list"
              :key="index"
              v-if="index > 0"
              class="content-box"
              :class="index % 2 === 0 ? 'content-animate-left' : 'content-animate-right'">
              <i></i>
              <div class="time">
                <span>{{ it.month }}</span>月
                <p>{{ it.year }}</p>
              </div>
              <div class="text">{{ it.content }}</div>
            </div>
            <div v-else class="forward">我们一直在前进</div>
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/pc/header'
import Footer from '@/components/pc/footer'
export default {
  data() {
    return {
      isShow: 'introduce',
      list: [
        { month: '04', year: '2023', content: '霖梓控股全面启动智能赛事产品线，同步开启全球化战略，开始布局欧洲、中东等地区' },
        { month: '12', year: '2022', content: '霖梓控股自建海外货仓与物流系统，覆盖全美所有区域' },
        { month: '12', year: '2022', content: '霖梓控股与朴道征信建立深度合作' },
        { month: '03', year: '2022', content: '霖梓控股第一代智能款家居健身产品研发成功，正式启动生产' },
        { month: '07', year: '2021', content: '霖梓控股获得信息系统安全等级保护三级认证' },
        { month: '04', year: '2021', content: '霖梓控股成为中国互联网金融协会会员' },
        { month: '02', year: '2021', content: '霖梓控股旗下“易借”业务拓展升级，推出金融科技平台“易借速贷”，进一步推进普惠金融服务' },
        { month: '01', year: '2021', content: '霖梓控股在线赛事业务正式立项' },
        { month: '06', year: '2020', content: '霖梓控股与锡商银行、马上金融开展合作' },
        { month: '12', year: '2019', content: '智能健身事业部成立，霖梓控股迈入国际化' },
        { month: '10', year: '2019', content: '物流事业部成立' },
        { month: '05', year: '2019', content: '百凌金科斩获零壹财经评选的“金融科技潜力50强”奖项' },
        { month: '02', year: '2019', content: '霖梓控股与大兴安岭银行开展合作' },
        { month: '12', year: '2018', content: '百凌金科与中国联通合作项目“易借”上线' },
        { month: '07', year: '2018', content: '瑞博国际物业管理公司成立' },
        { month: '02', year: '2018', content: '霖梓控股旗下“百凌金科”与易借品牌发布' },
        { month: '09', year: '2017', content: '霖梓控股成立，首次推出智能信贷服务' }
      ],
      temaList: [
        {
          name: '张杰',
          job: 'CEO',
          imgUrl: require('@/assets/img/pc/about/zhangjie.jpg'),
          introduce: [
            '八年知名互联网行业从业经验，连续创业者，拥有成熟的管理经验及成功创业经历，曾历任于阿里巴巴、菜鸟网络资深运营及高级产品专家，深度参与物流评价、智能分拣路由，四级地址库升级改造等数千万用户量级互联网创新项目；从零开始一手打造日均交易规模超5000万全国排名前五的某知名消费金融平台。',
            '在用户产品与运营、产品创新、市场营销等方面积累了丰富经验，对互联网、金融产业发展有着深刻的理解和富有远见的战略思维，擅长运用互联网的方法论和先进的产品运营实操，优化重塑传统业务的业务模式并提升效率。'
          ]
        },
        {
          name: '徐虹杰',
          job: 'CTO',
          imgUrl: require('@/assets/img/pc/about/xuhongjie.jpg'),
          introduce: [
            '十年以上知名互联网行业从业经验，连续创业者，历任TCL集团技术总监，阿里巴巴集团高级技术专家，阿拉丁电商&金融CTO，前后端技术架构师，主导完成googleTV和爱奇艺TV的从0到1的开发设计和投产上线，实现国内首批googleTV的系统设计和爱奇艺首批互联网TV的设计，深度参与天猫魔盒系统的v2.0系统和TV淘宝的核心开发设计，从零开始主导日均交易规模3000万+的消费金融平台51返呗的技术平台搭建和核心开发设计。在互联网技术开发，技术管理，运维安全管控方面积累了丰富经验，对互联网技术的演进和发展趋势有深刻认知，对互联网金融行业的发展和业务的走向有非常深刻的理解。擅长运用敏捷开发结合传统开发的模式来管理开发团队的高效高质量的落地项目。'
          ]
        },
        {
          name: '陈金虎',
          job: '首席架构师',
          imgUrl: require('@/assets/img/pc/about/chenjinhu.jpg'),
          introduce: [
            '10年以上互联网公司从业经验，多年互联网金融系统架构经验，曾就职于杭州阿拉丁、阿里巴巴、中信银行等多家上市公司，深度参与B2B CRM系统的重构、云OS相关系统的架构开发，拥有多个行业、业务系统、大数据体系架构经验，参与过亿级注册用户系统的开发与维护；着手架构并实现了多个千万级注册用户、日活百万级uv的系统；专业知识掌握牢固，多年团队管理经验，在高并发、分布式、微服方面具有丰富的经验。思维敏捷，业务理解能力强，超强的解决问题的能力。'
          ]
        },
        // {
        //   name: '邓玉良',
        //   job: 'CDO',
        //   imgUrl: require('@/assets/img/pc/about/dengyuliang.jpg'),
        //   introduce: [
        //     '拥有多年互联网大数据风控经验，在支付宝、阿里集团、同盾科技有多年反欺诈业务风控经验，主持过支付宝可信体系、蚂蚁金服网商银行风控体系、同盾反欺诈风控大脑等大型风控项目；擅长以风险过程的方法论的角度，构建可持续优化的互联网金融业务风险防控体系，有成熟的风险管理经验和风险定价能力。从零构建霖梓网络数据体系，支撑霖梓百凌金融100+互联网场景金融产品。'
        //   ]
        // },
        {
          name: '刘更顺',
          job: 'CPO',
          imgUrl: require('@/assets/img/pc/about/liugengshun.jpg'),
          introduce: [
            '具有丰富的互联网金融经验，主持过多个金融产品的建设及上线，包括货币基金产品、定投理财产品、供应链融资、消费金融、票据理财等；具有6年支付行业产品经验，深入理解第三方支付的业务模式、系统架构及安全规范。主持过多个支付系统产品的建设及优化，其中包括互联网支付系统、多用途预付费卡系统、智能POS收单等支付系统的建设。'
          ]
        },
        {
          name: '余发军',
          job: '无线架构师',
          imgUrl: require('@/assets/img/pc/about/yufajun.jpg'),
          introduce: [
            '10年大型互联网公司从业经验和管理经验，曾在H3C、UC、阿里巴巴、木仓科技等公司参与和主导Android/IOS/Web的开发，承担过UC九游、驾考宝典、教练宝典等月活千万级app核心开发工作，完成驾考宝典驾校业务线上交易等核心功能。对Android/IOS的框架、UI、组件、性能有深刻理解，擅长业务组件化、Hybrid、动态部署等开发，在产品交互体验上积累了丰富的实战经验。'
          ]
        }
      ]
    }
  },
  watch: {
    '$route'(to, from) {
      if(to.query.type) {
        window.scrollTo(0, 0)
        this.isShow = to.query.type || 'introduce'
      }
    }
  },
  mounted() {
    if(this.$route.query.type) {
      window.scrollTo(0, 0)
      this.isShow = this.$route.query.type || 'introduce'
    }
  },
  methods: {
    handleSubfield(show) {
      this.isShow = show
    },
    handleAnimation(index) {
      this.$refs.temaInfo.forEach((item, itemIndex) => {
        if (index === itemIndex) {
          if(item.classList.contains('showWidth')) {
            item.classList.remove('showWidth')
            item.classList.add('showWidthReverse')
          } else {
            item.classList.remove('showWidthReverse')
            item.classList.add('showWidth')
          }
        } else {
          item.classList.remove('showWidth')
        }
      });
    },
    hanldeClose(index) {
      this.$refs.temaInfo[index].classList.remove('showWidth')
      this.$refs.temaInfo[index].classList.add('showWidthReverse')
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="less">
  .about {
     display: flex;
     flex-direction: column;
    .banner {
      height: 450px;
      background: url('~@/assets/img/pc/about/about-banner.jpg') no-repeat center/cover;
      position: relative;
      h3 {
        font-size:46px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color: #fff;
        text-align: center;
        line-height: 450px;
      }
      .subfield {
        width: 100%;
        position: absolute;
        bottom: 0;
        background-color: rgba(30, 19, 18, 0.41);
        .subfield-box {
          ul {
            display: flex;
            width: 100%;
            li {
              flex: 1;
              text-align: center;
              font-size:14px;
              font-family:PingFangSC-Semibold;
              color:#fff;
              line-height: 50px;
              cursor: pointer;
            }
            .active {
              background: linear-gradient(to bottom, rgba(255,139,82,0.2) 0%, rgba(255,139,82,0.6) 100%);
            }
          }
        }
      }
    }
    main {
      padding-top: 80px;
      .introduce {
        padding-bottom: 80px;
        p {
          font-size:14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          font-weight:400;
          color:#333;
          line-height: 28px;
          margin-top: 40px;
        }
        p:nth-of-type(1) {
          margin-top: 60px;
        }
        .icon-box {
          display: flex;
          margin-top: 80px;
        }
        dl {
          flex: 1;
          text-align: center;
          img {
            width: 56px;
            height: 56px;
          }
          dd:nth-of-type(1){
            font-size:18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight:500;
            color:#333;
            line-height:25px;
            margin: 40px 0 20px;
          }
          dd:nth-of-type(2){
            font-size:14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight:400;
            color:#666;
            line-height:20px;
          }
        }
      }
      .develop {
        position: relative;
        .content {
          margin-top: 70px;
          width: 1200px;
          height: 2100px;
          position: relative;
          .forward {
            width: 432px;
            height: 115px;
            position: absolute;
            left: 143px;
            top: 0;
            font-size:14px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color: #FF8B52;
            text-align: right;
          }
          .progress {
            width: 1px;
            height: 2000px;
            background-color: #ccc;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
          }
          .content-box {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            width: 432px;
            height: 115px;
            position: absolute;
            background: url('~@/assets/img/pc/about/progressBlock-left.png') no-repeat center/cover;
            box-sizing: border-box;
            padding: 0 20px;
            i {
              width: 15px;
              height: 15px;
              border-radius: 7.5px;
              display: block;
              background-color: #FF8B52;
            }
            .time {
              font-size:15px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:#FF8B52;
              line-height:21px;
              padding-right: 12px;
              span {
                font-size:22px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:#FF8B52;
                line-height:21px;
              }
            }
            .time {
              border-right: 1px solid #ccc;
            }
            .text {
              width: 300px;
              font-size:15px;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:#666;
              line-height:21px;
              padding-left: 19px;
            }
          }
          .content-box:nth-of-type(2n) {
            background: url('~@/assets/img/pc/about/progressBlock-right.png') no-repeat center/cover;
          }
          .content-box:nth-of-type(2){
            top: (104px/2); 
          }
          .content-box:nth-of-type(3){
            top: ((104px/2) * 3); 
          }
          .content-box:nth-of-type(4){
            top: ((104px/2) * 5);
          }
          .content-box:nth-of-type(5){
            top: ((104px/2) * 7); 
          }
          .content-box:nth-of-type(6){
            top: ((104px/2) * 9);
          }
          .content-box:nth-of-type(7){
            top: ((104px/2) * 11); 
          }
          .content-box:nth-of-type(8){
            top: ((104px/2) * 13); 
          }
          .content-box:nth-of-type(9){
            top: ((104px/2) * 15); 
          }
          .content-box:nth-of-type(10){
            top: ((104px/2) * 17); 
          }
          .content-box:nth-of-type(11){
            top: ((104px/2) * 19); 
          }
          .content-box:nth-of-type(12){
            top: ((104px/2) * 21); 
          }
          .content-box:nth-of-type(13){
            top: ((104px/2) * 23); 
          }
          .content-box:nth-of-type(14){
            top: ((104px/2) * 25); 
          }
          .content-box:nth-of-type(15){
            top: ((104px/2) * 27); 
          }
          .content-box:nth-of-type(16){
            top: ((104px/2) * 29); 
          }
          .content-box:nth-of-type(17){
            top: ((104px/2) * 31); 
          }
          .content-box:nth-of-type(18){
            top: ((104px/2) * 33); 
          }
          .content-animate-left {
            animation: developHistoryLeft .6s ease forwards;
            i {
              position: absolute;
              right: -32px;
            }
          }
          .content-animate-right {
            animation: developHistoryRight .6s ease forwards;
            padding-left: 32px;
            i {
              position: absolute;
              left: -32px;
            }
          }
        }
      }
      .tema {
        padding-bottom: 290px;
        > p {
          margin-top: 70px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:#333;
          text-indent: 2em;
          line-height: 24px;
        }
        h3 {
          font-size:18px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color: #333;
          line-height:20px;
          margin-top: 66px;
          margin-bottom: 34px;
        }
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            cursor: pointer;
            margin: 0 18px 26px 0;
            position: relative;
            .tema-content {
              width: 335px;
              height: 290px;
              position: relative;
              .img-box {
                width: 100%;
                img {
                  width: 100%;
                }
              }
              .name, .job {
                position: absolute;
                left: 25px;
                font-family: PingFangSC-Regular, sans-serif;
                font-weight: 300;
              }
              .name {
                top: 45px;
                font-size: 17px;
              }
              .job {
                top: 70px;
                font-size: 12px;
                letter-spacing: 1px;
              }
            }
            .info {
              position: absolute;
              width: 0;
              height: 290px;
              box-sizing: border-box;
              background: #f5f5f5;
              z-index: 996;
              transition: all 1s;
              overflow: hidden;
              
              h5 {
                display: inline-block;
                color: #f46800;
                text-transform: uppercase;
                font-size: 28px;
                margin-bottom: 15px;
              }
              span {
                font-size: 18px;
                color: #666;
                margin-left: 10px;
              }
              p {
                font-size: 14px;
                font-family: PingFangSC-Regular, sans-serif;
                text-indent: 28px;
                color: #333333;
                line-height: 20px;
              }
              div {
                position: absolute;
                right: 40px;
                top: 20px;
                width: 25px;
                height: 25px;
                transition: all .2s;
                background: url('~@/assets/img/pc/about/close.png') no-repeat center/cover;
              }
              div:hover {
                transform: rotate(90deg);
              }
            }
            i {
              width: 30px;
              height: 30px;
              position: absolute;
              right: 10px;
              bottom: 10px;
              transition: background .2s;
              background: url('~@/assets/img/pc/about/arrow.png') no-repeat center/cover;
            }
          }
          li:nth-of-type(1), li:nth-of-type(4) {
            .info {
              top: 0;
              left: 335px;
            }
          }
          li:nth-of-type(3n) {
            margin-right: 0;
            .info {
              top: 0;
              right: 335px;
            }
          }
          li:hover i{
            background: url('~@/assets/img/pc/about/arrow_hover.png') no-repeat center/cover;
          }
          .showWidth {
            animation: showWidth .6s forwards;
          }
          .showWidthReverse{
            animation: showWidthReverse .4s forwards;
          }
        }
      }
    }
  }
</style>
